module.exports = "@media screen and (max-width: 1070px){\r\n  .logged-user{\r\n    font-size: small;\r\n    /* display: none; */\r\n  }\r\n}\r\n"